export default {
    init() {
    },
    finalize() {

        jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#password_1").keyup(function(e){

            window.checkPasswordStrength(jQuery(this),jQuery('#password_strength'), [], jQuery('form.edit-account button'), true );
            
        });
    }
};


// WEBPACK FOOTER //
// ./js/routes/woocommerce-account-edit-account.js